import { Prescription, ExerciseInPlan } from "../types";

export type WorkoutPlanFormInput = {
  name: string;
  professionalId: string;
  studentId: string;
  validade: string | null;
  prescriptions: Prescription[];
};

/**
 * Payload alinhado a POST/PUT /workout-plans/ a partir do formulário do site.
 */
export function buildWorkoutPlanPayload(input: WorkoutPlanFormInput) {
  return {
    plan_name: input.name,
    professional_id: input.professionalId,
    user_id: input.studentId,
    validade: input.validade || null,
    prescriptions: input.prescriptions.map((p) => ({
      name: p.name,
      observation: String(p.observation ?? "").trim(),
      exercises: p.exercises.map((e: ExerciseInPlan) => {
        const sets = String(e.sets ?? e.series ?? "").trim();
        const reps = String(e.reps ?? e.repetitions ?? "").trim();
        const load = String(e.load ?? e.charge ?? "").trim();
        const interval = String(e.interval ?? "").trim();
        const observation = String(e.observation ?? "").trim();

        return {
          id: Number(e.id) || 0,
          name: e.name || "",
          sets,
          reps,
          series: sets,
          repetitions: reps,
          load,
          interval: interval || undefined,
          observation: observation || undefined,
          professional: Number(input.professionalId),
        };
      }),
    })),
  };
}
